import { Activity } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import { LastStatusWeb } from "./web";
import { LastStatusWebEditor } from "./web-editor";
import { LastStatusPanelRenderer } from "./web-panel";

export default registerBlock({
  type: "last-status",
  name: "editorBlocksLibrary.blocks.last-status.title",
  description: "editorBlocksLibrary.blocks.last-status.description",
  Icon: Activity,
  category: BlockCategory.TRACKING,
  components: {
    web: {
      component: LastStatusWeb,
      editor: { component: LastStatusWebEditor },
      configPanel: {
        component: LastStatusPanelRenderer,
        features: {
          delete: true,
        },
      },
      compatibility: {
        rowBlock: {
          minSize: 2,
        },
      },
    },
  },
});
